'use strict';

const mixin = {
	created() {
		console.log('app created');
		this.loadData();
	},
	methods: {
		loadMap() {
			console.log(`${(this._vnode || {}).tag}: election > loadData > loadMap`);
			this.$store.dispatch('loadMap', this.year)
		},
		loadResults() {
			console.log(`${(this._vnode || {}).tag}: election > loadData > loadResults`);
			this.$store.dispatch('loadResults', this.year)
		},
		loadCalledSeats() {
			console.log(`${(this._vnode || {}).tag}: election > loadData > loadCalledSeats`);
			this.$store.dispatch('loadCalledSeats', this.year)
		},
		loadAllResults() {
			console.log(`${(this._vnode || {}).tag}: election > loadData > loadAllResults`);
			this.$store.dispatch('loadAllResults', this.year)
		},
		loadData() {
			this.loadMap();
			// this.loadResults();
			// this.loadCalledSeats();
			this.loadAllResults();
		}
	}
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/loadData.js